
import cmBlank from '@/components/cmBlank.vue'
import cmLoadmore from '@/components/cmLoadmore.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'


export default {
name: 'order',
directives: {
TransferDom
},
components: {
cmBlank,cmLoadmore,PopupPicker,Previewer,Popup,XButton,Radio, Group,PopupHeader
},
data () {
return {
title:'全部订单',
diffPop:false,
popBg:false,
amount:'',
id:0,
grade:0,
isActive:0,
pop:false,
blankShow:false,
loadStatus:false,
loadmoreText:'正在加载。。。',
busy:false,
phone:'',
pageFlag:2,
hasNext:0,
lastId:0,
type:0,
itemId:0,
list:[],
pickerStatus:false,
worker:[],
worker_id:0,
updateUid:0,
comment:{
star:0,
star1:0
},
showCommentStatus:false,
check:'/static/images/start@2x.png',
checked:'/static/images/started@2x.png',
options: {
getThumbBoundsFn (index) {
let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
let rect = thumbnail.getBoundingClientRect()
return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
},
}
}
},
created(){
this.type = Number(this.$route.params.type);
this.isActive = Number(this.$route.params.i);
this.grade = parseInt(this.$func.getLocal('grade'));
},
methods:{
copy(val){
this.$func.copy(val,event);
},
search(){
this.list = [];
this.lastId = 0;
this.hasNext = 0;
this.getList();
},
selectStatus(key){
this.loadStatus = false;
this.where = [];
this.where['status'] = key;
this.isActive = key;
this.lastId = 0;
this.list = [];
this.getList();
},
getList(){
this.$api.getSubOrderLists({type:this.type,last_id:this.lastId,page_flag:this.pageFlag,phone:this.phone,status:this.isActive}).then((res)=>{
if(res){

if(!this.lastId){
this.blankShow = res.data.length > 0 ? false : true;
}
this.hasNext = res.hasNext;
this.lastId = res.lastId;
res.data.forEach((item)=>{
this.list.push(item);
});
}
})
},
show (index) {
this.$refs.previewer.show(index)
},
openDiffPop(id){
this.diffPop = true;
this.popBg = true;
this.id = id;
},
closePop(){
this.diffPop = false;
this.popBg = false;
},
diffPay(){
if(this.amount <= 0){
this.$func.showToast('请输入补差价金额');
return false;
}
if (typeof WeixinJSBridge == "undefined"){
if( document.addEventListener ){
document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
}else if (document.attachEvent){
document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
}
}else{
this.onBridgeReady();
}
},
onBridgeReady(){
let that = this;
this.$api.diffPrice({amount:this.amount,id:this.id}).then((res)=>{
if(res){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data,
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
setTimeout(()=>{
that.search();
},300);
}else{
that.$func.showToast('已取消支付');
}
that.id = 0;
that.closePop();
}
);
}
})
},
loadmore(){
if(this.lastId > 0 && !this.hasNext){
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
return ;
}
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '正在加载。。。';

this.getList();
setTimeout(()=>{
if(this.blankShow){
this.busy = true;
this.loadStatus = false;
this.loadmoreText = '没有更多了。。。'
}else{
if(this.hasNext > 0){
this.loadStatus = false;
this.busy = false;
}else{
this.busy = true;
this.loadStatus = true;
this.loadmoreText = '没有更多了。。。'
}
}
},1500)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/suborder.vue